module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-beijing.8928b09b.png";